// extracted by mini-css-extract-plugin
export var divider = "_12-0";
export var dividerText = "_12-1";